import React from 'react'
import IconWrapper, { IconProps } from './IconWrapper'

export default function ArrowRight(props: IconProps) {
    return (
        <IconWrapper {...props}>
            <svg
                width="10"
                height="8"
                viewBox="0 0 10 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g id="Group">
                    <path
                        id="Vector"
                        d="M8.33366 4H1.66699"
                        stroke="#fff"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        id="Vector_2"
                        d="M5.66699 6.66671L8.33366 4.00004L5.66699 1.33337"
                        stroke="#fff"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </g>
            </svg>
        </IconWrapper>
    )
}
